export default "__VITE_ASSET__DKwWQn5G__"